import * as types from './actionTypes';
import * as api from '../../api/loginApi';

export function signIn(user) {
    return function (dispatch) {
        return api.login(user)
            .then(user => {
                localStorage.setItem('profile', JSON.stringify(user))
                dispatch({ type: types.LOGIN_SUCCESS, user })
            })
            .catch(error => {
                throw error
            })
    }
}

export function signUp(user) {
    return function (dispatch) {
        return api.register(user)
            .then(user => {
                localStorage.setItem('profile', JSON.stringify(user))
                dispatch({ type: types.LOGIN_SUCCESS, user })
            })
            .catch(error => {
                throw error
            })
    }
}

export function forgotPassword(email) {
    return function (dispatch) {
        return api.resetPassword(email)
            .then(email => {

            })
            .catch(error => {
                throw error
            })
    }
}

export function oauthLogin(data) {
    return function (dispatch) {
        return api.oauthLogin(data)
            .then((user) => {
                data.result._id = user.result._id;
                data.token = user.token
                localStorage.setItem('profile', JSON.stringify(data))
                dispatch({ type: types.OAUTH_LOGIN_SUCCESS, data })
            })
            .catch(error => {
                throw error
            })
    }
}

export function logout() {
    return function (dispatch) {
        localStorage.removeItem('profile');
        return dispatch({ type: types.LOGOUT_SUCCESS })
    }
}

